const capabilities = {
    app: ['loader', 'paginator', 'filter', 'sorter', 'exporter', 'importer', 'error-logger'],
    entity: ['safe-deleter', 'locker']
};

export default capabilities;
